import React from "react";
import hairColorTryImg from "./../../../../../Images/Blog/25+ Hair Colors/Banner.png";

const HairColorTryImg = () => {
  return (
    <div className="blogImg-content">
      <img src={hairColorTryImg} alt="hairColorTryImg" loading="lazy" />
    </div>
  );
};

export default HairColorTryImg;
